module.exports = __webpack_public_path__ + "img/5.bf8edc08.png";